/** @module SiteAdmin/CrewUserRolesTable */
define([
	"dojo/_base/declare",
	"csi/core/ExtendedPath",
	"csi/reflection",
	"csi/state",
	"csi/table/Widget",
	"csi/xml",
	"SiteAdmin"
], function(declare, ExtendedPath, reflection, state, Widget, xml, SiteAdmin) {

	return declare(Widget, {
		disableCustomViewToolbar: true,

		/** @property {boolean} displayGlobalAssignments - indicates whether the toggle is set, true for set, false for unset */
		displayGlobalAssignments: false,

		/** @property {boolean} bFreezeToggle - flag to freeze or unfreeze toggle based on whether users have been assigned to roles at this level */
		bFreezeToggle: false,

		// @property {boolean} isForAssignedAgentCrew - indicates whether the table is for AssignedAgentCrewRoleUsers
		isForAssignedAgentCrew: false,


		/**
		 * @override
		 * reset stores to clean up old reports
		 */
		_buildView: function() {
			if (state.get("print")) {
				this._resetStores();
			}
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Clean up old reports
		 */
		_resetStores: function() {
			const cache = this.cacheView;

			cache.query({"$Type": "CrewAssignmentReport"}).forEach(function(node) {
				cache.remove(node.$URL);
			});

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Don't add dependency paths as server uses Dep.CrewUserAssignment
		 */
		onCreateMainQueryLevel: function(ql) {
			const cache = this.getCache();
			const crewURL = SiteAdmin.getOnlineSupplierCrew(cache, this.getViewNode(), this.isForAssignedAgentCrew);
			const crewNode = cache.getNode(crewURL);
			const users = this.cacheView.getPathNodes(crewNode, "Child:Assignments/Child:AssignedUsers");

			if (!users || !users.length) {
				this.displayGlobalAssignments = true;
				this.bFreezeToggle = true;
			} else {
				this.bFreezeToggle = false;
			}

			ql.requestParameters = {
				"Dep.CrewUserAssignment": crewURL,
				"Dep.CrewIncludeGlobal": false,
				"Qry.Limit.Path": (!this.displayGlobalAssignments) ?
					[xml.getUrlPath(this.urlRoot, xml.path(xml.ATTR_PARENT, this.isForAssignedAgentCrew ? "AssignedAgentCrew" : "Crew", "Assignments", "AssignedUsers")),
					xml.getUrlPath(this.urlRoot, xml.path("Assignments", "Role"))] : null
			};

			if (!this.relRoot.m_addPaths) {
				var crew = this.getViewNode();
				var rc = reflection.getNodeClass(crew);
				if (rc && rc.isDerivedFrom("OnlineCrew")) {
					var config = this.cacheView.getPathNode(crew, "Child:__Parent__/Child:CrewType/Child:Production");
					if (config && !config.AllowGlobalUsers) {
						var paths = [xml.getUrlPath(this.urlRoot, "Child:CrewUsers")];

						if (crew.$Type == "SupplierCrew") {
							var ep = new ExtendedPath("SupplierCrew");
							ep.addRelationStep("__Parent__", "Supplier");
							ep.addRelationStep("Agent");
							ep.addRelationStep("Crew");
							ep.addRelationStep("CrewUsers");
							paths.push(xml.getUrlPath(this.urlRoot, ep.toString()));
						}

						ql.requestParameters["Qry.Limit.Path"] = paths;
					}
				}
			}
		}
	});
});